import type { TOC } from '@ember/component/template-only';
import type { CustomEmberTableColumn } from '@mylighthouse/prism-ember/types/components/prism/table';

interface HotelPricingAssistantTableCellsThCompetitorMonthSignature {
  Args: {
    column: CustomEmberTableColumn;
  };
}

const HotelPricingAssistantTableCellsThCompetitorMonth = <template>
  <span
    class="block truncate text-right"
    data-test-id="th-competitor-month"
    title={{@column.name}}
  >{{@column.name}}</span>
</template> satisfies TOC<HotelPricingAssistantTableCellsThCompetitorMonthSignature>;

export default HotelPricingAssistantTableCellsThCompetitorMonth;
